// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyCell = {
    // Undo sticky table from prestyles
    css: css`
        height: 60px;
        border-bottom: none;
        padding-top: 10px;
        min-width: 300px;
        ${xScreen("lte", "sm")} {
            &&& {
                position: static;
            }
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        text-align: right;
        padding-top: 10px;
        min-width: unset;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.buttonsCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        text-align: right;
        padding-top: 20px;
        min-width: auto;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.calculatorCell = {
    css: css`
        display: block;
        position: absolute;
        width: 100%;
        height: 60px;
        padding-top: 10px;
        border: none;
        left: 0;
        min-width: 300px;
        max-width: 300px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.methodGridItem = {
    width: 7,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.percentGridItem = {
    width: 3,
    align: "bottom",
};

rfqQuoteDetailsQuoteLineCalculatorStyles.percentTextField = {
    cssOverrides: {
        formField: css`
            width: 60px;
            min-width: 40px;
        `,
    },
};
